import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setEntryFormErrors, updateEntryForm } from "../../redux/entrySlice";
import { createNewEntry } from "../../api/entryAPI";
import { getOne } from "../../api/breakAPI";
import Loader from "../Loader";

function EntryForm() {
    // STATE/HOOKS =========================================================================================
    const {id} = useParams();
    const navigate = useNavigate();
    const token = useSelector(state => state.user.token);
    const breakDetail = useSelector(state => state.breaks.breakDetail);
    const message = useSelector(state => state.entries.message);
    const formState = useSelector(state => state.entries.form);
    const loading = useSelector(state => state.entries.loading)
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(getOne({id, token}))
    }, [dispatch, id, token])

    // HANDLERS =========================================================================================
    const validate = () => {
        let valid = true;
        let newDate;
        let msTo45Days = 1000*60*60*24*45;

        if (formState.date !== "") {
            let dateArray = formState.date.split("-");
            newDate = new Date(`${Number(dateArray[0])}`,`${Number(dateArray[1]) - 1}`,`${Number(dateArray[2])}`)
        }

        if (formState.date === "") {
            valid = false;
            dispatch(setEntryFormErrors("Must input a date"))
        } else if ((Date.now() - msTo45Days > newDate) ) {
            valid = false;
            dispatch(setEntryFormErrors("Date has to be within 45 days of today"))
        }else if (formState.startTime === "") {
            valid = false;
            dispatch(setEntryFormErrors("Must input a start time"))
        } else if (formState.endTime === "") {
            valid = false;
            dispatch(setEntryFormErrors("Must input an end time"))
        }

        return valid;
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (validate()) {
            let dateArray = formState.date.split("-");
            let buoyIds = breakDetail.buoys.map(buoy => buoy.id);
            const submitData = {
                breakID: id,
                date: new Date(`${Number(dateArray[0])}`,`${Number(dateArray[1]) - 1}`,`${Number(dateArray[2])}`),
                startTime: formState.startTime,
                endTime: formState.endTime,
                notes: formState.notes,
                buoyIds: buoyIds
            }

            dispatch(createNewEntry({submitData, token, id, navigate}))
        }
    }

    // DOM RENDER =========================================================================================
    return(
        <div className="content">
            {loading && <div className="modal">
                <div className="modal-content">
                    <Loader />
                </div>
            </div>}

            <h1>New Journal Entry for {breakDetail.name}</h1>

            <form className="form shadow-lg mobile-w-10-12">
                <label htmlFor='date' className='form-label'>Date</label>
                <input 
                    type="date" 
                    name="date" 
                    id="date"
                    value={formState.date} 
                    onChange={(event) => dispatch(updateEntryForm({field: event.target.name, value: event.target.value}))} 
                    className='w-80 mobile-w-11-12'
                />

                <label htmlFor='startTime' className='form-label'>Start Time</label>
                <input 
                    type="time" 
                    name="startTime" 
                    id="startTime" 
                    value={formState.startTime} 
                    onChange={(event) => dispatch(updateEntryForm({field: event.target.name, value: event.target.value}))} 
                    className='w-80 mobile-w-11-12'
                />

                <label htmlFor='endTime' className='form-label'>End Time</label>
                <input 
                    type="time" 
                    name="endTime" 
                    id="endTime" 
                    value={formState.endTime} 
                    onChange={(event) => dispatch(updateEntryForm({field: event.target.name, value: event.target.value}))} 
                    className='w-80 mobile-w-11-12'
                />

                <label htmlFor='notes' className='form-label'>Notes</label>
                <textarea 
                    name="notes" 
                    id="notes" 
                    rows="6"
                    cols="50"
                    value={formState.notes} 
                    onChange={(event) => dispatch(updateEntryForm({field: event.target.name, value: event.target.value}))} 
                    placeholder="Enter any more notes here" 
                    className="mobile-w-11-12"
                />

                <br></br>
                <p className='my-5 text-red-500 font-bold'>{formState.error}</p>
                <button className="btn-primary" onClick={(event) => handleSubmit(event)}>Submit</button>
            </form>

            <p className='my-5 text-green-500 font-bold'>{message}</p>
            
        </div>
    )
}

export default EntryForm;